<template>
  <div :style="{ width: `${width}px` }">
    <div class="mb-1 flex items-center gap-2">
      <app-rating-stars :value="rating.global_satisfaction" />
      <p class="mt-px text-sm">
        <strong class="text-base">{{ rating.global_satisfaction }}</strong
        >/5
      </p>
      <p class="flex-auto text-right text-sm text-subtle">
        {{ formatedCreationDate }}
      </p>
    </div>

    <p class="mb-1 font-semibold">
      {{ rating.author.full_name_abbreviated }}
      <template v-if="rating.author.job_title || rating.author.company_name">
        - {{ rating.author.job_title }} @{{ rating.author.company_name }}
      </template>
    </p>

    <p class="mb-6 line-clamp-6">
      {{ rating.comment }}
    </p>

    <figure class="flex items-center gap-2">
      <app-user-avatar
        :avatar-url="rating.course.teacher.avatar_url"
        :name="rating.course.teacher.full_name"
        :size="48"
        tile
      />
      <div>
        <p class="line-clamp-1 font-semibold">
          {{ rating.course.title }}
        </p>
        <p class="text-sm text-subtle">
          {{ rating.course.teacher.full_name }}
        </p>
      </div>
    </figure>
  </div>
</template>

<script lang="ts" setup>
import {
  type CarouselProvidedState,
  CarouselProvideKey,
} from "~/shared/carousel/carousel.model";
import type { RatingListApiView } from "~~/model/rating.model";

const properties = defineProps<{
  rating: RatingListApiView;
}>();

const width = inject<CarouselProvidedState | null>(
  CarouselProvideKey,
)?.itemWidth;

const formatedCreationDate = useI18nRelativeTime(properties.rating.created_at);
</script>
